import {
  ArticleFooterContributorInfo,
  ArticleFooterContributorInfoProps,
} from "design-system/components/pages/article-page/article-footer/article-footer-contributor-info";

export interface ContributorProps {
  editors: Array<ArticleFooterContributorInfoProps>;
  photographers: Array<ArticleFooterContributorInfoProps>;
  photoeditors: Array<ArticleFooterContributorInfoProps>;
  illustrators: Array<ArticleFooterContributorInfoProps>;
  interviewees: Array<ArticleFooterContributorInfoProps>;
  interviewers: Array<ArticleFooterContributorInfoProps>;
  translators: Array<ArticleFooterContributorInfoProps>;
  hosts: Array<ArticleFooterContributorInfoProps>;
  videographers: Array<ArticleFooterContributorInfoProps>;
  narrators: Array<ArticleFooterContributorInfoProps>;
  additionalCredits: Array<ArticleFooterContributorInfoProps>;
}

export const Contributors = (entry: ContributorProps) => {
  return (
    <>
      {!!entry.editors?.length && (
        <div className="hbs-article-footer__row">
          <h2 className="hbs-article-footer__row-heading">Editor:</h2>
          <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
            {entry.editors.map((person, i) => (
              <ArticleFooterContributorInfo {...person} key={i} />
            ))}
          </div>
        </div>
      )}
      {!!entry.hosts?.length && (
        <div className="hbs-article-footer__row">
          <h2 className="hbs-article-footer__row-heading">Host:</h2>
          <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
            {entry.hosts.map((person, i) => (
              <ArticleFooterContributorInfo {...person} key={i} />
            ))}
          </div>
        </div>
      )}
      {!!entry.illustrators?.length && (
        <div className="hbs-article-footer__row">
          <h2 className="hbs-article-footer__row-heading">Illustrator:</h2>
          <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
            {entry.illustrators.map((person, i) => (
              <ArticleFooterContributorInfo {...person} key={i} />
            ))}
          </div>
        </div>
      )}
      {!!entry.interviewees?.length && (
        <div className="hbs-article-footer__row">
          <h2 className="hbs-article-footer__row-heading">Interviewee:</h2>
          <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
            {entry.interviewees.map((person, i) => (
              <ArticleFooterContributorInfo {...person} key={i} />
            ))}
          </div>
        </div>
      )}
      {!!entry.interviewers?.length && (
        <div className="hbs-article-footer__row">
          <h2 className="hbs-article-footer__row-heading">Interviewer:</h2>
          <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
            {entry.interviewers.map((person, i) => (
              <ArticleFooterContributorInfo {...person} key={i} />
            ))}
          </div>
        </div>
      )}
      {!!entry.narrators?.length && (
        <div className="hbs-article-footer__row">
          <h2 className="hbs-article-footer__row-heading">Narrator:</h2>
          <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
            {entry.narrators.map((person, i) => (
              <ArticleFooterContributorInfo {...person} key={i} />
            ))}
          </div>
        </div>
      )}
      {!!entry.photographers?.length && (
        <div className="hbs-article-footer__row">
          <h2 className="hbs-article-footer__row-heading">Photographer:</h2>
          <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
            {entry.photographers.map((person, i) => (
              <ArticleFooterContributorInfo {...person} key={i} />
            ))}
          </div>
        </div>
      )}
      {!!entry.photoeditors?.length && (
        <div className="hbs-article-footer__row">
          <h2 className="hbs-article-footer__row-heading">Photo Editor:</h2>
          <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
            {entry.photoeditors.map((person, i) => (
              <ArticleFooterContributorInfo {...person} key={i} />
            ))}
          </div>
        </div>
      )}
      {!!entry.translators?.length && (
        <div className="hbs-article-footer__row">
          <h2 className="hbs-article-footer__row-heading">Translator:</h2>
          <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
            {entry.translators.map((person, i) => (
              <ArticleFooterContributorInfo {...person} key={i} />
            ))}
          </div>
        </div>
      )}
      {!!entry.videographers?.length && (
        <div className="hbs-article-footer__row">
          <h2 className="hbs-article-footer__row-heading">Videographer:</h2>
          <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
            {entry.videographers.map((person, i) => (
              <ArticleFooterContributorInfo {...person} key={i} />
            ))}
          </div>
        </div>
      )}
      {!!entry.additionalCredits?.length && (
        <div className="hbs-article-footer__row">
          <h2 className="hbs-article-footer__row-heading">
            Additional Credits:
          </h2>
          <div className="hbs-article-footer__row-content hbs-article-footer__row-content--contributor">
            {entry.additionalCredits.map((person, i) => (
              <ArticleFooterContributorInfo
                {...person}
                isAdditionalCredits
                key={i}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};
